import webmRecorder from './WebmRecorder';
import recorderPolyfill from './RecorderPolyfill';
import platformDetection from './PlatformDetection';

const audioRecorder = {
    audioContext: undefined,
    recorder: undefined,
    isInitProcess: false,
    isRecordAvailable: false,
    initHandler: undefined,
    useWebmEncoder: true,//window.location.href.indexOf('stage') != -1,
    usePolyFill: platformDetection.isSafari() || platformDetection.isEdge() || platformDetection.isChromeBook() || platformDetection.isMac(),

    init(initHandler) {
        this.initHandler = initHandler;
        this.isInitProcess = true;

        // try {
        //     this.useWebmEncoder = (MediaRecorder.isTypeSupported('audio/webm'));
        // } catch (e) {
        // }

        try {
            window.AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext;
            window.URL = window.URL || window.webkitURL;

            this.audioContext = new AudioContext();

            // Older browsers might not implement mediaDevices at all, so we set an empty object first
            if (navigator.mediaDevices === undefined) {
                navigator.mediaDevices = {};
            }

            // Some browsers partially implement mediaDevices. We can't just assign an object
            // with getUserMedia as it would overwrite existing properties.
            // Here, we will just add the getUserMedia property if it's missing.
            if (navigator.mediaDevices.getUserMedia === undefined) {
                navigator.mediaDevices.getUserMedia = function (constraints) {

                    // First get ahold of the legacy getUserMedia, if present
                    var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

                    // Some browsers just don't implement it - return a rejected promise with an error
                    // to keep a consistent interface
                    if (!getUserMedia) {
                        return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
                    }

                    // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
                    return new Promise(function (resolve, reject) {
                        getUserMedia.call(navigator, constraints, resolve, reject);
                    });
                };
            }

            navigator.mediaDevices.getUserMedia({audio: true}).then(this.startUserMedia.bind(this)).catch(this.handlerErrorUserMedia.bind(this));
        } catch (e) {
            this.handlerErrorUserMedia(e);
        }
    },
    handlerErrorUserMedia(err) {
        var text = '';

        if (err.name == "NotFoundError" || err.name == "DevicesNotFoundError") {
            text = 'Required track is missing!';
        } else if (err.name == "NotReadableError" || err.name == "TrackStartError") {
            text = 'Webcam or microphone are already in use!';
        } else if (err.name == "OverconstrainedError" || err.name == "ConstraintNotSatisfiedError") {
            text = 'Constraints can not be satisfied by avb. devices!';
        } else if (err.name == "NotAllowedError" || err.name == "PermissionDeniedError") {
            text = 'Permission denied in browser!';
        } else if (err.name == "TypeError" || err.name == "TypeError") {
            text = 'Empty constraints object!';
        } else {
            //other errors
            text = err.name;
        }

        alert(text);
    },
    startUserMedia(stream) {
        var input = this.audioContext.createMediaStreamSource(stream);

        console.log('Media stream created.');

        // Create an Analyser - we need this for microphone level
        var analyser = this.audioContext.createAnalyser();
        input.connect(analyser);

        // if (MediaRecorder.isTypeSupported('audio/webm')) {
            this.recorder = webmRecorder;
            this.recorder.init(this.audioContext, input, stream, analyser);
        // } else {
        //     if (this.usePolyFill) {
        //         this.recorder = recorderPolyfill;
        //         this.recorder.init(this.audioContext, input, stream, analyser);
        //     } else {
        //         this.recorder = new Recorder(this.audioContext, input, stream, analyser);
        //     }
        // }

        this.isInitProcess = false;
        this.isRecordAvailable = true;

        if (this.initHandler)
            this.initHandler();

        console.log('Recorder initialised.');
    },
    startRecording() {
        if (!this.recorder)
            return;

        this.recorder.record();
        console.log('Recording...');
    },
    stopRecording(endRecording) {
        if (!this.recorder)
            return;

        this.recorder.stop(endRecording);
        console.log('Stopped recording.');
    },
    getMicrophoneLevel() {
        if (!this.recorder)
            return 0;

        return this.recorder.microphoneLevel();
    },
    cancel() {
        if (this.recorder)
            this.recorder.cancelStream();
    }
};

export default audioRecorder;



/** WEBPACK FOOTER **
 ** ./src/components/utils/AudioRecorder.js
 **/